export const USER_QUERY_KEYS = {
  default: () => ['user'] as const,
  getMe: () => [...USER_QUERY_KEYS.default(), 'me'] as const,
  updateUser: () => [...USER_QUERY_KEYS.default(), 'updateUser'] as const,
};
